import { parseNthPhoneDigits } from './resolveOfficeTelHref.js';

/** WhatsApp chat line (second office number when contact_phone has two lines). */
export const DEFAULT_OFFICE_WHATSAPP_DIGITS = '8799470699';

export const DEFAULT_WHATSAPP_PREFILL_MESSAGE = `Hello!
Can I get more information about your upcoming trek.`;

export function buildWhatsAppHref(digits, message = DEFAULT_WHATSAPP_PREFILL_MESSAGE) {
  const d = String(digits || '').replace(/\D/g, '');
  if (!d) return null;
  const phone = d.length === 10 ? `91${d}` : d.startsWith('91') ? d : `91${d.slice(-10)}`;
  const text = encodeURIComponent(String(message || DEFAULT_WHATSAPP_PREFILL_MESSAGE).trim());
  return `https://wa.me/${phone}?text=${text}`;
}

/** Share text/link via WhatsApp (no recipient — user picks a contact). */
export function buildWhatsAppShareHref(message) {
  const text = String(message || '').trim();
  if (!text) return null;
  return `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
}

/** Office WhatsApp — second line of `contact_phone`, else 9913800699; message prefilled as Hello. */
export function resolveOfficeWhatsAppHref(contactPhoneSetting) {
  const digits = parseNthPhoneDigits(contactPhoneSetting, 1) || DEFAULT_OFFICE_WHATSAPP_DIGITS;
  return buildWhatsAppHref(digits, DEFAULT_WHATSAPP_PREFILL_MESSAGE);
}
